'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-next-line react/prefer-stateless-function
exports.default = _react2.default.createClass({
  displayName: 'UIMediaRight',

  propTypes: {
    children: _react.PropTypes.node,
    className: _react.PropTypes.string
  },

  render: function render() {
    var _props = this.props,
        children = _props.children,
        className = _props.className;

    return _react2.default.createElement(
      'div',
      { className: (0, _reactUtils.classNames)('private-media__item', 'private-media__item--right', className) },
      children
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.348/js/layout/UIMediaRight.js
// module id = 254
// module chunks = 0 1